import React, { Component } from 'react';
import Button from '../Part_Sample/Button';
import { getSceneIcon } from '../Common/Common';
import bookmark from '../../Images/Icons/bookmark.png';
import bookmark_on from '../../Images/Icons/bookmark_on.png';

export default class Scene_Cell extends Component {
	constructor(props) {
		super(props);
		let bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (controller_info.bookmark_list != null) {
			if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
				bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username]
			}
		}

		if (bookmark_list.scenes == null || bookmark_list.scenes == undefined) {
			bookmark_list.scenes = [];
		}

		let is_bookmark = false;

		if (bookmark_list.scenes.length > 0 && bookmark_list.scenes.includes(this.props.id)) {
			is_bookmark = true;
		}

		this.state = {
			is_bookmark: is_bookmark,
			is_cell_focused: false,
		}

	}

	handleToggleBookmark = (e) => {
		e.stopPropagation();
		let is_bookmark = !this.state.is_bookmark;
		this.setState({ is_bookmark: is_bookmark });

		let bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (controller_info.bookmark_list == null) {
			controller_info.bookmark_list = {};
			controller_info.bookmark_list[this.props.receiver.active_controller.username] = {};
		} else if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
			bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username];
		}

		if (bookmark_list.scenes == null || bookmark_list.scenes == undefined) {
			bookmark_list.scenes = [];
		}

		if (is_bookmark && !bookmark_list.scenes.includes(this.props.id)) {
			bookmark_list.scenes.push(this.props.id);
		} else if (!is_bookmark && bookmark_list.scenes.includes(this.props.id)) {
			bookmark_list.scenes.splice(bookmark_list.scenes.indexOf(this.props.id), 1);
		}

		controller_info.bookmark_list[this.props.receiver.active_controller.username] = bookmark_list;
		window.localStorage.setItem(this.props.receiver.active_controller.name, JSON.stringify(controller_info));
	}

	handleExecuteScene = (scene_id) => {
		document.getElementById(this.props.id + '_cell_internal').classList.remove('flipInY');
		document.getElementById(this.props.id + '_cell_internal').classList.add('fadeIn');
		setTimeout(() => {
			if (document.getElementById(this.props.id + '_cell_internal') != null) {
				document.getElementById(this.props.id + '_cell_internal').classList.remove('fadeIn');
			}
		}, 300);
		this.props.receiver.executeScene(scene_id);
	}
	render() {
		// Cell_width = 100
		let cell_width = 145;

		// Height : cell_width
		let cell_style = {
			cursor: 'pointer',
			width: cell_width,
			height: 100,
			margin: 5,
			padding: 10,
			borderRadius: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			display: 'inline-block',
			verticalAlign: 'top'
		}

		let icon = getSceneIcon(this.props.scene.icon);

		return (
			<div id={this.props.id + '_cell_internal'} className='flipInY' style={cell_style} onClick={() => this.handleExecuteScene(this.props.id)}>
				<div style={{ cursor: 'pointer', display: 'inline-block', width: 25 }}>
					<img src={this.state.is_bookmark ? bookmark_on : bookmark} style={{ width: 25, }} onClick={this.handleToggleBookmark} />
				</div>
				<div style={{ display: 'inline-block', width: cell_width - 30, verticalAlign: 'top', textAlign: 'left' }}>
					<span id={this.props.id + '_cell_span'} style={{ fontSize: 12, marginLeft: 5 }}>{this.props.scene.name}</span>
				</div>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<img src={icon} style={{ width: 60, height: 60 }} />
				</div>
			</div>
		)
	}
}